import * as React from "react";
import {cx} from "emotion";

import "./editing.scss";

import {bindInput}        from "@Common/react/bind-input";
import {cs}               from "@Common/react/chain-services";
import {keyed}            from "@Common/react/keyed";
import {scopedState}      from "@Common/react/scoped-state";
import {scn}              from "@Common/react/state-change-nested-value";
import {Static2}          from "@Common/react/static-2";
import {UseState}         from "@Common/react/use-state";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";
import {createArray}      from "@Common/utils/collections";

export const Editing = ({editing, saved, onCancel, onSave, next}) => cs(
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ["showErrors", (_, next) => UseState({next})],
    ({domRef, eh, showErrors}) => next({
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
            showErrors.onChange(true);
        },
        render: ({showErrors: forcedShowErrors}) => cs(
            keyed("editing"),
            ["apiError", (_, next) => UseState({next})],
            ["error", (_, next) => next(
                Object.keys(editing.value).filter((k) => /^line\d$/.test(k) && editing.value[k]).length < 3 &&
                "Permit information is not complete. Per USPS standards, permit must have at least 3 lines."
            )],
            ({apiError, error}) => (
                <div className="editing-7um">

                    <div className={cx("left", !error && !apiError.value && eh.css)}>

                        <div className="title" xd-qa-type="text" xd-qa-name={(saved ? "Update" : "Add") + " Permit"}>
                            {saved ? "Update" : "Add"} Permit:
                        </div>
                        <div className={cx("content")} ref={domRef.set}>
                            <div className="lines">
                                {createArray(5).map((i) => (
                                    <div className="line" key={i}>
                                        <div className="label" xd-qa-type="text" xd-qa-name={"Line " + (i+1)}>
                                            Line {i+1}
                                        </div>

                                        <div className="input">
                                            <input {...{
                                                ...bindInput(scopedState(editing, ["line" + (i+1)])),
                                                onBlur: () => {
                                                    if (apiError.value) {
                                                        apiError.onChange(null);
                                                    }
                                                    scn(editing, ["line" + (i + 1)], (v) => v?.toUpperCase());
                                                }
                                            }}
                                                xd-qa-type="textbox"
                                                xd-qa-name={"Line " + (i+1)}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {(showErrors.value || forcedShowErrors) && !!error && (
                                <div className={cx("error", eh.css)} xd-qa-type="text" xd-qa-name="Error">
                                    {error}
                                </div>
                            )}

                            {(showErrors.value || forcedShowErrors) && apiError.value && (
                                <div className={cx("error", eh.css)} xd-qa-type="text" xd-qa-name="API Error">
                                    {apiError.value}
                                </div>
                            )}

                            <div className="actions">
                                {cs(
                                    ["submitting", (_, next) => UseState({next})],
                                    ({submitting}) => (
                                        <button {...{
                                            className: cx({disabled: error}),
                                            onClick: async () => {
                                                showErrors.onChange(true);
                                                if (!error) {
                                                    submitting.onChange(true);
                                                    try {
                                                        await onSave();
                                                    } catch (e) {
                                                        apiError.onChange(e);
                                                    } finally {
                                                        submitting.onChange(false);
                                                    }
                                                }
                                            },
                                            disabled: submitting.value,
                                        }}
                                            xd-qa-type="button"
                                            xd-qa-name={saved ? "SAVE" : "ADD"}
                                        >
                                            {saved ? "SAVE" : "ADD"}
                                        </button>
                                    )
                                )}

                                <button {...{
                                    onClick: onCancel,
                                }}
                                    xd-qa-type="button"
                                    xd-qa-name="CANCEL"
                                >CANCEL</button>
                            </div>
                        </div>
                    </div>
                </div>
            ),
        ),
    })
);

